var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57303 1.70147C8.37283 1.51127 8.05635 1.51939 7.86616 1.71959C7.67596 1.91979 7.68408 2.23627 7.88428 2.42647L12.7466 7.04562H1.00018C0.724041 7.04562 0.500183 7.26948 0.500183 7.54562C0.500183 7.82177 0.724041 8.04562 1.00018 8.04562H12.7472L7.88428 12.6654C7.68408 12.8556 7.67596 13.172 7.86616 13.3722C8.05635 13.5725 8.37283 13.5806 8.57303 13.3904L14.3327 7.91867C14.4352 7.82711 14.4998 7.6939 14.4998 7.54562C14.4998 7.39359 14.4319 7.25741 14.3249 7.16571L8.57303 1.70147Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.545898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLight);
export default __webpack_public_path__ + "static/media/arrow-right-light.a3d2db1d570d157dbe08119ab032e156.svg";
export { ForwardRef as ReactComponent };